import React from 'react';
import ErrorReportStore from '@/stores/ErrorReportStore';

class ErrorBoundary extends React.Component<{ groupName: string; children: React.ReactNode }> {
  constructor(props) {
    super(props);
    this.state = { hasError: false, groupName: props.groupName };
  }

  static getDerivedStateFromError() {
    return { hasError: true };
  }

  override componentDidCatch(error: { message: any; }) {
    ErrorReportStore.log({
      groupName: `popularKeyword > ${this.state.groupName}`,
      detail: {
        error: error.message,
        etc: window.location.href,
      },
      userAgent: ErrorReportStore.getUserAgent(),
      poc: ErrorReportStore.getPoc().APP_POPULAR,
    });
  }

  override render() {
    if (this.state.hasError) return null;
    return this.props.children;
  }
}

export default ErrorBoundary;
